<template>
    <div class="mcomarall">
        <Header :header="header"></Header>   
        <!--依照套用參數進入樣板-->
        <component :is="currentComponent" v-model="querylist"></component >     
    </div>
</template>
<script>
//標頭
import Header from '../../components/admin/NavBar/Header.vue';

export default{
    components:{
        Header
    },
    data(){
        return{
            //標頭
            header:{
                text1:"友站連結",
                text2:"次類別文字"
            },
            //樣式名稱
            currentComponent:null,
            //頁面參數
            querylist:{},
        }
    },
    props:[],
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        "$route.query"(){
            //初始化
            this.init();
        }
    },
    methods:{
        //初始化
        init(){
            this.querylist = this.$route.query;
            if(this.querylist.lang==null){
                this.querylist.lang = "1";
            }
            this.querylist.PJID = "PJ202510";
            this.querylist.modal = "2";
    },
        //切換內容畫面
        async createView(){
            //初始化
            this.init();
            
        //取得網址的樣式名稱，並進行動態轉換，以減少讀取時間
            switch(this.querylist.modal){
            //單一頁面
            case "1":
                //切換樣式，並匯入必要參數

                break;
            
            //列表頁面
            case "2":
                //切換樣式，並匯入必要參數
                this.currentComponent = (await import('../../components/admin/Content/Links/Content.vue')).default;
                
                break;
            //內容頁面
            case "3":
                //切換樣式，並匯入必要參數
                this.currentComponent = (await import('../../components/admin/Content/Links/Content.vue')).default;
                
                break;
            //從資料庫取得樣式
            case undefined:
                //TODO 動態讀取頁面功能
                break;
        }
        }
    },
    async created(){
        this.createView();
    }
}
</script>